<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Employee Offboarding"
                :btnTitle="'Add New'"
                :showAddNew="true"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <ListTable
                :tableItems="tableItems"
                :contactInfo="contactInfo"
                :formData="formData"
                :getOffBoardingList="getOffBoardingList"
            />
        </div>

        <EmployeeOffBoardingModal
            v-if="store.state.isModalOpenTwo"
            :formData="formData"
            :contactInfo="contactInfo"
            @getOffBoardingList="getOffBoardingList"
        />

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import ListTable from '@/components/molecule/company/hrm-payroll/employee-off-boarding/ListTable.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleContact from '@/services/modules/contact'
import EmployeeOffBoardingModal from '@/components/molecule/company/hrm-payroll/employee-off-boarding/EmployeeOffBoardingModal.vue';

const props = defineProps({
  contactInfo: {
    type: Object
  }
})

const formData = ref({
  contact_profile_id: props.contactInfo.id,
  off_boarding_type_id:null,
  details_reason:null,
  last_working_date:null,
  is_edit:false,
  attachments:[]
})

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const contactProfileId = ref('');
let contacts = ref([])
const tableItems = ref([]);
const params = ref({
    offset: 30,
});

const token = computed(() => localStorage.getItem('token'));

const {
  fetchEmployeeOffBoardingData,
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact()

const onClickToGo = () => {
   getOffBoardingList();
}

function onClickAddNewButton() {
  store.state.isModalOpenTwo = true
}

const getOffBoardingList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchEmployeeOffBoardingData(query).then(res => {
        if (!res.status){
            return
        }

        tableItems.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    if (props.contactInfo) query += '&contact_profile_id=' + props.contactInfo.id
    query += '&offset=' + params.value.offset
    return query;
}

</script>
